import { render, staticRenderFns } from "./TabTerminado.vue?vue&type=template&id=268c0f0a"
import script from "./TabTerminado.vue?vue&type=script&lang=js"
export * from "./TabTerminado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('268c0f0a')) {
      api.createRecord('268c0f0a', component.options)
    } else {
      api.reload('268c0f0a', component.options)
    }
    module.hot.accept("./TabTerminado.vue?vue&type=template&id=268c0f0a", function () {
      api.rerender('268c0f0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/tasks/validaciones/formalizacionactas/TabTerminado.vue"
export default component.exports